module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-zy.60d947cc.png";